import _ from 'lodash';

export default class Product {
  constructor(data) {
    // It's a good practice to use lodash getters
    this.productId = _.get(data, 'productId');
    this.storeId = _.get(data, 'storeId');
    this.date = _.get(data, 'date');
    this.name = _.get(data, 'name');
    this.unit = _.get(data, 'unit');
    this.stockJ = _.get(data, 'stockJ', undefined);
    this.stockJAv = _.get(data, 'stockJAv', undefined);
    this.stockJAr = _.get(data, 'stockJAr', undefined);
  }

  get displayName() {
    return this.name;
  }

  get displayUnit() {
    return this.unit;
  }
}
